import { Injectable } from '@angular/core';

import { ClientConfigProductName } from '../client-config/client-config-product-name.model';
import { ProductService } from '../products/product.service';
import { ApiBase } from './api-base.service';
import { ApiServiceFactory } from './api-service-factory.service';

@Injectable({
    providedIn: 'root',
    useFactory: promoApiServiceFactory,
    deps: [ApiServiceFactory, ProductService],
})
export class PromoApiService extends ApiBase {}

export function promoApiServiceFactory(apiServiceFactory: ApiServiceFactory, productService: ProductService) {
    return apiServiceFactory.createForProduct(PromoApiService, {
        product: ClientConfigProductName.PROMO,
        area: 'promo',
        forwardProductApiRequestHeader: productService.getMetadata(ClientConfigProductName.PROMO).isEnabledProductApi,
    });
}
